import { Box, Typography } from "@mui/material";
import * as React from "react";

interface IProps {
    text: string | string[];
}
export const MprcCaptionBullets = ({ text }: IProps) => {
    const tarr = Array.isArray(text) ? text : [text];

    return (
        <Box>
            {
                tarr.map((text, index) => (
                    <Typography
                        key={index}
                        component="p"
                        variant="caption"
                        sx={
                            {
                                listStyleType: "disc",
                                display: "list-item",
                                marginLeft: 2
                            }
                        }
                    >
                        {text}
                    </Typography>
                ))
            }
        </Box>
    );
}
